<template>
	<div class="layout" :class='$helper.get("i18n_lang")'>
		<LayoutHead  v-if="!isMobileFlag"/>
		<router-view :key="$route.fullPath"/>
		<LayoutFoot :footNav="footNavs" :footNavs2="footNavs2" v-if="isHomePage || !isMobileFlag" />
		<leftAside></leftAside>
	</div>
</template>
<script>
	import leftAside from '@/components/leftAside.vue'
	import LayoutHead from './components/LayoutHead.vue'
	import LayoutFoot from './components/LayoutFoot.vue'
	import {index_notice_list_api} from '@/api/index'
	export default {
		components:{
			LayoutHead,
			LayoutFoot,
			leftAside
		},
		data() {
			return {
				topNavs:[],
				footNavs:[],
				footNavs2:[],
			};
		},
		computed: {
		    isHomePage() {
		      // 假设首页的路由路径是 '/'
		      return this.$route.path === '/';
		    }
		},
		methods:{
			async getNotice(typeid) {
				let param = {};
				const res = await index_notice_list_api(param);
				if (res && res.data.code == 1) {
					this.topNavs = res.data.data;
					this.footNavs = res.data.data.filter(item => item.is_nav === 4);
					this.footNavs2 = res.data.data.filter(item => item.is_nav === 6);
					this.$helper.set("topNavs", this.topNavs);
				}
			}
		},
		mounted() {
			this.getNotice();
		}
	}
</script>
